const mediaSlider = () => {
    const mediaSliders = document.querySelectorAll('.media-list-slider_container');

    mediaSliders.forEach(mediaSlider => {
        const swiperSlider = mediaSlider.querySelector('swiper-slider');

        // Ensure the swiperSlider and its mainSwiper are available before adding event listeners
        if (!swiperSlider || !swiperSlider.mainSwiper) {
            return;
        }

        // Pause all videos when slider transitions start
        if (swiperSlider.mainSwiper) {
            swiperSlider.mainSwiper.on('slideChangeTransitionStart', function () {
                const allVideos = mediaSlider.querySelectorAll('video');
                allVideos.forEach(video => {
                    if (!video.paused) {
                        video.pause();
                    }
                });
            });

            // Reset video states after transition ends
            swiperSlider.mainSwiper.on('slideChangeTransitionEnd', function () {
                const allVideos = mediaSlider.querySelectorAll('video');
                allVideos.forEach(video => {
                    // Reset video to beginning
                    video.currentTime = 0;
                });
            });
        }

        swiperSlider.mainSwiper.slides.forEach(slide => {
            slide.addEventListener('mouseover', function (e) {
                const video = slide.querySelector('video');
                if (video) {
                    // Only play if video is not already playing and slider is not transitioning
                    if (video.paused && swiperSlider.mainSwiper && !swiperSlider.mainSwiper.animating) {
                        // Try to play the video with error handling
                        const playPromise = video.play();
                        
                        if (playPromise !== undefined) {
                            playPromise
                                .then(() => {
                                    // Video started playing successfully
                                    console.log('Video started playing on hover');
                                })
                                .catch(error => {
                                    // Handle autoplay restriction or other errors
                                    console.log('Video autoplay prevented:', error.message);
                                    // Optionally, you can show a play button or handle differently
                                });
                        }
                    }
                }
            });

            // Voice control button click handler
            const voiceControl = slide.querySelector('.media-list-voice__control');
            if (voiceControl) {
                voiceControl.addEventListener('click', function (e) {
                    e.preventDefault();
                    
                    const video = slide.querySelector('video');
                    if (video) {
                        // Toggle mute state

                        voiceControl.classList.toggle('muted')

                        if (voiceControl.classList.contains('muted')) {
                            video.muted = true;
                        } else {
                            video.muted = false;
                        }
                    }
                });
            }

            // Pause video when mouse leaves
            slide.addEventListener('mouseout', function (e) {
                const video = slide.querySelector('video');
                if (video && !video.paused) {
                    video.pause();
                }
            });

            // Initialize color swatches
            initializeColorSwatches(slide);
            
            // Initialize Safari-compatible add to cart for media list slider
            initializeMediaListAddToCart(slide);
        });
    })
}

// Function to update product image when color swatch is clicked
function updateProductImage(swatchElement, imageUrl, variantId, variantPrice, variantAvailable) {
    // Remove active class from all swatches in the same product
    const productContainer = swatchElement.closest('.media-list-item--product');
    const allSwatches = productContainer.querySelectorAll('.media-list-item--product-color-item');
    allSwatches.forEach(swatch => swatch.classList.remove('active'));
    
    // Add active class to clicked swatch
    swatchElement.classList.add('active');
    
    // Update the product image
    const productImage = productContainer.querySelector('.media-list-item--product-media img');
    if (productImage && imageUrl) {
        productImage.src = imageUrl;
        productImage.style.opacity = '0.7';
        
        // Smooth transition effect
        setTimeout(() => {
            productImage.style.opacity = '1';
        }, 150);
    }
    
    // Update the variant ID for the add to cart button
    const addToCartButton = productContainer.querySelector('[data-add-to-cart-button]');
    if (addToCartButton && variantId) {
        addToCartButton.setAttribute('data-variant-id', variantId);
        addToCartButton.setAttribute('data-current-variant-id', variantId);
        
        // Update the button's disabled state based on variant availability
        if (variantAvailable === 'false') {
            addToCartButton.disabled = true;
            addToCartButton.classList.add('btn-soldout');
        } else {
            addToCartButton.disabled = false;
            addToCartButton.classList.remove('btn-soldout');
        }
    }
    
    // Update the price display
    if (variantPrice) {
        const priceSpan = addToCartButton.querySelector('span');
        if (priceSpan) {
            priceSpan.textContent = variantPrice;
        }
    }
}

// Function to initialize color swatches
function initializeColorSwatches(slide) {
    const colorSwatches = slide.querySelectorAll('.media-list-item--product-color-item');
    
    colorSwatches.forEach((swatch, index) => {
        // Set first swatch as active by default
        if (index === 0) {
            swatch.classList.add('active');
        }
        
        // Add click event listener
        swatch.addEventListener('click', function(e) {
            e.preventDefault();
            const imageUrl = this.getAttribute('data-variant-image');
            const variantId = this.getAttribute('data-variant-id');
            const variantPrice = this.getAttribute('data-variant-price');
            const variantAvailable = this.getAttribute('data-variant-available');
            updateProductImage(this, imageUrl, variantId, variantPrice, variantAvailable);
        });
    });
}

// Function to initialize Safari-compatible add to cart for media list slider
function initializeMediaListAddToCart(slide) {
    const addToCartButtons = slide.querySelectorAll('[data-add-to-cart-button]');
    
    addToCartButtons.forEach(button => {
        // Remove existing listeners to avoid duplicates
        button.removeEventListener('click', handleMediaListAddToCart);
        // Add Safari-compatible event listener
        button.addEventListener('click', handleMediaListAddToCart);
    });
}

// Safari-compatible add to cart handler for media list slider
function handleMediaListAddToCart(e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    
    const button = e.currentTarget;
    const variantId = button.getAttribute('data-variant-id') || button.getAttribute('data-current-variant-id');
    
    // Check if button is disabled or already loading
    if (button.disabled || button.classList.contains('btn--loading')) {
        return false;
    }
    
    // Add loading state
    button.classList.add('btn--loading');
    
    const formData = {
        id: parseInt(variantId),
        quantity: 1
    };
    
    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(data => {
        // Safari-compatible CustomEvent creation
        let cartBuildEvent, cartOpenEvent;
        try {
            cartBuildEvent = new CustomEvent('cart:build');
            cartOpenEvent = new CustomEvent('cart:open');
        } catch (error) {
            // Fallback for older Safari versions
            cartBuildEvent = document.createEvent('CustomEvent');
            cartBuildEvent.initCustomEvent('cart:build', true, true, {});
            cartOpenEvent = document.createEvent('CustomEvent');
            cartOpenEvent.initCustomEvent('cart:open', true, true, {});
        }
        
        document.dispatchEvent(cartBuildEvent);
        document.dispatchEvent(cartOpenEvent);
        button.classList.remove('btn--loading');
    })
    .catch(error => {
        console.error('Add to cart error:', error);
        button.classList.remove('btn--loading');
    });
    
    return false;
}

document.addEventListener('DOMContentLoaded', mediaSlider);